<template>
  <div>
    <p>
      פחות מ-5 משרות אחיות מחוברות למשרה, נא לחבר משרות נוספות לפני שמתחילים עבודה ייעודית
    </p>
    <div class="columns is-align-items-center ">
      <div class="column m-6">
        <img
          class="operation_icon mx-auto"
          src="/group.svg"
          @click.self="openDesignatedPositions" />
      </div>
      <div class="column m-6 has-text-centered">
        <button class="button is-info" @click="closeModal">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'ModalDesignatedPositionFeedConformation',
  props: {
    position: {
      type: Object
    }
  },
  methods: {
    ...mapMutations('modals', ['create', 'removeModalById']),
    closeModal () {
      this.removeModalById(this.$attrs.payload.modal_id)
    },
    openDesignatedPositions () {
      this.create({
        designator: 'connected-position-manager-modal',
        component_name: 'ConnectedPositionManager',
        position: this.position,
        modal_title: this.position.title + ' - Connected Position Manager',
        is_center_modal: true,
        modal_width: 1400
      })
    }
  }
}
</script>
